export default __webpack_public_path__ + "static/media/yo.531a6203.png";